const updates = [
  { date: '07.28', title: '《绝世神医》第 312 话更新，主角解锁全新至尊技能树', tag: '爆更' },
  { date: '07.28', title: '本周人气榜刷新：《重生之都市修仙》重回榜首', tag: '榜变' },
  { date: '07.27', title: '新作《九尾狐的恋爱法则》上线首周突破 50 万阅读', tag: '新番' },
  { date: '07.27', title: '浪漫恋爱题材热度飙升，三部高分作品同时进入前十', tag: '趋势' },
  { date: '07.26', title: '《暗影刺客成长记》第二季宣布连载，读者期待值拉满', tag: '续作' },
  { date: '07.26', title: '本站韩国漫画大全收录突破 1000 部，覆盖全热门题材', tag: '里程碑' },
  { date: '07.25', title: '奇幻冒险类韩国漫画推荐专题上线，精选 20 部必看佳作', tag: '专题' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">最新动态</h2>
          <p className="mt-3 text-sm text-foreground-600">韩国漫画每日更新快讯 · 最快掌握动态</p>
        </div>

        <div className="max-w-2xl mx-auto relative">
          <div className="absolute left-[19px] top-2 bottom-2 w-px bg-background-300/60"></div>

          <div className="flex flex-col gap-1">
            {updates.map((item, i) => (
              <div key={i} className="relative flex items-start gap-5 pl-2 py-2.5">
                <div className="relative z-10 w-[38px] h-[38px] rounded-full bg-primary-100 border-2 border-primary-400 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <span className="text-[10px] font-heading text-primary-700 whitespace-nowrap leading-tight text-center">{item.date}</span>
                </div>
                <div className="flex-1 min-w-0 pt-1">
                  <h3 className="text-sm text-foreground-800 leading-relaxed">{item.title}</h3>
                </div>
                <span className="flex-shrink-0 text-xs px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 whitespace-nowrap mt-1.5">
                  {item.tag}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}